(() => {
    let _carouselSlider = {
        'syncHeight' : function(_this) {
            // sync product names height
            let max = 28;
            $(_this).closest('.section-collection-carousel--wrapper').find('.card--media > .card__content .card__information > h3.card__heading').removeAttr('style');
            $.each($(_this).closest('.section-collection-carousel--wrapper').find('.card--media > .card__content .card__information > h3.card__heading'), function(k,v) {
                max = ($(v).height() > max) ? $(v).height() : max;
            });
            $(_this).closest('.section-collection-carousel--wrapper').find('.card--media > .card__content .card__information > h3.card__heading').css({
                'height' : max + 'px'
            });
        },
        'checkSlick' : function(_this, slick, cs) {
            let i = (cs ? cs : 0) + 1;
            let ic = (slick.$dots[0].children.length == 0) ? 1 : (slick.$dots[0].children.length);
            $(_this).closest('.section-collection-carousel--wrapper').find('.slick-page-indicator').text(i + '/' + ic);

            if (slick.$dots[0].children.length <= 1) {
                $(_this).closest('.section-collection-carousel--wrapper').addClass('noslick');
            } else {
                $(_this).closest('.section-collection-carousel--wrapper').removeClass('noslick');
            }

            if ($(_this).closest('.section-collection-carousel--wrapper').find('.slick-prev.slick-arrow').hasClass('slick-disabled')) {
                $(_this).closest('.section-collection-carousel--wrapper').find('.slick-prev-trigger').attr('disabled', 'disabled');
            } else {
                $(_this).closest('.section-collection-carousel--wrapper').find('.slick-prev-trigger').removeAttr('disabled');
            }
            if ($(_this).closest('.section-collection-carousel--wrapper').find('.slick-next.slick-arrow').hasClass('slick-disabled')) {
                $(_this).closest('.section-collection-carousel--wrapper').find('.slick-next-trigger').attr('disabled', 'disabled');
            } else {
                $(_this).closest('.section-collection-carousel--wrapper').find('.slick-next-trigger').removeAttr('disabled');
            }
        }
    };
    
    setTimeout(function() {
        let slickLength = 4;
        $('.carousel-v2 .slider-wrapper').on('init', function(event, slick, cs) {
            _carouselSlider.checkSlick(this, slick, cs);
    
            $(this).closest('.section-collection-carousel--wrapper').find('.slick-prev-trigger').on('click', function() {
                console.log('prev');
                $(this).closest('.section-collection-carousel--wrapper').find('.slider-container button.slick-prev').trigger('click');
            });
            $(this).closest('.section-collection-carousel--wrapper').find('.slick-next-trigger').on('click', function() {
                console.log('next');
                $(this).closest('.section-collection-carousel--wrapper').find('.slider-container button.slick-next').trigger('click');
            });
            $(this).closest('.section-collection-carousel--wrapper').find('.slider-container button.slick-prev, .slider-container button.slick-next').attr({
                'aria-hidden': true,
                'tabindex': -1
            });
            
            if($(this).closest('section').find('.slick-track:empty').length > 0 || $(this).closest('section').find('ul.slider-wrapper:empty').length > 0) {
                $(this).closest('section').attr('aria-hidden', true);
                $(this).closest('.carousel-v2').attr('aria-hidden', true);
            } else {
                $(this).closest('.carousel-v2').addClass('init');
            }
            // setTimeout(function() {
            //     _carouselSlider.syncHeight(this);
            // }, 300);
    
            _carouselSlider.checkSlick(this, slick);
            slickLength = ($(this).closest('.slider-container').find('ul.slider-wrapper .grid__item').length > 4) ? slickLength : 1;
        }).slick({
            dots: true,
            arrows: true,
            swipe: true,
            slidesToShow: slickLength,
            slidesToScroll: 1,
            swipeToSlide: true,
            infinite: false,
            prevArrow: "<button type='button' class='slick-prev'>Prev</button>",
            nextArrow: "<button type='button' class='slick-next'>Next</button>",
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        }).on('beforeChange', function(event, slick, cs, ns) {
            // $(this).closest('.slider-container').find('.slick-dots li').removeClass('active');
            // $.each($(this).closest('.slider-container').find('.slick-dots li'), function() {
            //     $(this).closest('li').addClass('active');
            //     if ($(this).closest('li').find('#slick-slide-control0'+ns).length > 0) {
            //         return false;
            //     }
            // });
        }).on('afterChange', function(event, slick, cs) {
            _carouselSlider.checkSlick(this, slick, cs);
            // _carouselSlider.syncHeight(this);
        });
    }, 200);
})();
